import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { Print } from "./Print"
import { useSaleOrderModel } from "../saleOrderModel";

export default () => {
    const { offerPrint, salePrint } = useSaleOrderModel()
    return (
        <>
            <PageHeader />
            <DataBox />
            <Print />
        </>
    )
}